module.exports = __webpack_public_path__ + "kishoralo-white-58ba5cda169dd542ff8d.svg";